

var _squid = require('squid');

require('./directive');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BmlApplyRoute', function () {

    return _squid.$ComponentRoute.extend('BmlApplyRoute', {

        name: 'bmlapply',
        trackingData: {
            fptiState: 'ppc_apply',
            buzname: {
                'fullpage': {
                    'pagename': '%::ppc_apply',
                    'pagename2': '%::ppc_apply:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },
        directive: 'xo-bml-apply-page',
        titleContent: 'applyForBml.bmlApplyHeadline',

        children: []

    });
});

_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/route.js
// module id = ../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/route.js
// module chunks = 0